export default __webpack_public_path__ + "static/media/milstone_icon.1af62ba7.svg";